// extracted by mini-css-extract-plugin
export var button = "_jw-2";
export var card = "_jw-0";
export var closeButtonContainer = "_jw-3";
export var iconContainer = "_jw-1";